(function () {
  if (window.__productCardVideoLoaded) return;
  window.__productCardVideoLoaded = true;

  const loadedProducts = new Map();

  function getProductPath(url) {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      const match = parsedUrl.pathname.match(/\/products\/[^/?#]+/);
      return match ? match[0] : null;
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariantId(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    try {
      const parsedUrl = new URL(link.href, window.location.origin);
      return parsedUrl.searchParams.get('variant');
    } catch (error) {
      return null;
    }
  }

  function normalizeImageUrl(url) {
    if (!url) return null;

    return url.split('?')[0];
  }

  function getMediaImageUrl(media) {
    return normalizeImageUrl(media.src || (media.preview_image && media.preview_image.src));
  }

  function getVariant(product, variantId) {
    if (!Array.isArray(product.variants)) return null;

    if (variantId) {
      return product.variants.find((variant) => String(variant.id) === String(variantId)) || null;
    }

    return product.variants.find((variant) => variant.available) || product.variants[0] || null;
  }

  function getVariantStartPosition(product, variant) {
    const featuredImageUrl = normalizeImageUrl(variant && variant.featured_image && variant.featured_image.src);
    if (!featuredImageUrl || !Array.isArray(product.media)) return null;

    const media = product.media.find((item) => getMediaImageUrl(item) === featuredImageUrl);
    return media ? media.position : null;
  }

  function getNextVariantStartPosition(product, currentPosition) {
    if (!Array.isArray(product.variants) || currentPosition == null) return null;

    const positions = product.variants
      .map((variant) => getVariantStartPosition(product, variant))
      .filter((position, index, items) => position != null && position > currentPosition && items.indexOf(position) === index)
      .sort((a, b) => a - b);

    return positions[0] || null;
  }

  function getDistinctVariantStartPositions(product) {
    if (!Array.isArray(product.variants)) return [];

    return product.variants
      .map((variant) => getVariantStartPosition(product, variant))
      .filter((position, index, items) => position != null && items.indexOf(position) === index)
      .sort((a, b) => a - b);
  }

  function getVideoMedia(product, variantId) {
    if (!Array.isArray(product.media)) return null;

    const variant = getVariant(product, variantId);
    const variantStartPosition = variant ? getVariantStartPosition(product, variant) : null;
    const nextVariantStartPosition = getNextVariantStartPosition(product, variantStartPosition);
    const distinctVariantStartPositions = getDistinctVariantStartPositions(product);
    const videos = product.media.filter((media) => media.media_type === 'video' || media.media_type === 'external_video');

    if (variant && variant.id) {
      const variantVideo = videos.find((media) => {
        return Array.isArray(media.variant_ids) && media.variant_ids.some((id) => String(id) === String(variant.id));
      });

      if (variantVideo) return variantVideo;
    }

    if (distinctVariantStartPositions.length <= 1) {
      return videos[0] || null;
    }

    if (variantStartPosition != null) {
      return videos.find((media) => {
        const isAfterVariantImage = media.position > variantStartPosition;
        const isBeforeNextVariant = nextVariantStartPosition == null || media.position < nextVariantStartPosition;

        return isAfterVariantImage && isBeforeNextVariant;
      }) || null;
    }

    return videos.length === 1 ? videos[0] : null;
  }

  function getVideoSource(media) {
    if (!Array.isArray(media.sources)) return null;

    const mp4Source = media.sources.find((source) => source.format === 'mp4' || source.mime_type === 'video/mp4');
    return mp4Source || media.sources[0] || null;
  }

  function buildVideo(media) {
    if (media.media_type !== 'video') return null;

    const source = getVideoSource(media);
    if (!source || !source.url) return null;

    const video = document.createElement('video');
    video.className = 'product-card-video';
    video.autoplay = true;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('aria-hidden', 'true');

    if (media.preview_image && media.preview_image.src) {
      video.poster = media.preview_image.src;
    }

    const sourceElement = document.createElement('source');
    sourceElement.src = source.url;
    sourceElement.type = source.mime_type || 'video/mp4';
    video.appendChild(sourceElement);

    video.addEventListener('canplay', () => {
      video.play().catch(() => {});
    }, { once: true });

    return video;
  }

  function replaceThemeCard(card, video) {
    const media = card.querySelector('.card__media .media');
    if (!media || media.querySelector('.product-card-video')) return;

    media.querySelectorAll('img, .card__video').forEach((image) => {
      image.style.display = 'none';
    });
    media.prepend(video);
  }

  function replaceGloboCard(card, video) {
    const media = card.querySelector('.spf-product-card__image-wrapper');
    if (!media || media.querySelector('.product-card-video')) return;

    media.querySelectorAll('.spf-product-card__image').forEach((image) => {
      image.style.display = 'none';
    });
    media.prepend(video);
  }

  function resetCardVideo(card) {
    card.querySelectorAll('.product-card-video').forEach((video) => video.remove());
    card.querySelectorAll('.spf-product-card__image, .card__media .media > img, .card__video').forEach((image) => {
      image.style.display = '';
    });
  }

  function applyVideo(card, media) {
    const video = buildVideo(media);
    if (!video) return;

    if (card.matches('.spf-product-card')) {
      replaceGloboCard(card, video);
    } else {
      replaceThemeCard(card, video);
    }
  }

  async function loadProduct(path) {
    if (!loadedProducts.has(path)) {
      loadedProducts.set(
        path,
        fetch(`${path}.js`)
          .then((response) => response.ok ? response.json() : null)
          .catch(() => null)
      );
    }

    return loadedProducts.get(path);
  }

  async function hydrateCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    const productPath = getProductPath(link.href);
    if (!productPath) return;

    const variantId = getSelectedVariantId(card);
    const cardKey = `${productPath}:${variantId || ''}`;

    if (card.dataset.productCardVideoKey === cardKey) return;

    card.dataset.productCardVideoKey = cardKey;
    resetCardVideo(card);

    const product = await loadProduct(productPath);
    const media = product ? getVideoMedia(product, variantId) : null;

    if (media) {
      applyVideo(card, media);
    }
  }

  function hydrateCards() {
    document.querySelectorAll('.card-wrapper, .spf-product-card').forEach(hydrateCard);
  }

  document.addEventListener('DOMContentLoaded', hydrateCards);
  document.addEventListener('shopify:section:load', hydrateCards);
  document.addEventListener('globoFilterRenderCompleted', hydrateCards);
  document.addEventListener('gspfRenderCompleted', hydrateCards);

  const observer = new MutationObserver(() => hydrateCards());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
